import _URL from '../URL/index';
const axios = _URL.axios;
const limit = 15;

export default {
    services: {
        newReservation: (reservation, token = "") => {
            return axios(token).post(`/reservations`, { reservation: reservation })
        },
        getReservations: (limit = 15, page = 1, query = "", token = "") => {
            return axios(token).get(`/reservations?limit=${limit}&page=${page}${query ? `&${query}` : ""}`)
        },
        getMetadataReservations: (query = "", token = "") => {
            return axios(token).get(`/reservations/metadata/quitFilter${query ? `?${query}` : ""}`)
        },
        getReservation: (reservationId, token = "") => {
            return axios(token).get(`/reservations/${reservationId}`)
        },
        updateReservation: (reservationId, reservation, recipients, reason, token) => {
            return axios(token).put(`/reservations/${reservationId}`, { reservation: reservation, recipients: recipients, reason: reason })
        },
        deleteReservation: (reservationId, token = "") => {
            return axios(token).delete(`/reservations/${reservationId}`)
        },
        deleteReservationMany: (reservations, token = "") => {
            return axios(token).put(`/deleteMany/reservations`, { reservations: reservations })
        },
        updateStatusReservation: (reservationId, payload, responsible, role, token = "") => {
            if (responsible) {
                return axios(token).put(`/reservations/status/changue/${reservationId}`, payload, { headers: { "responsible": responsible, "role": role } })
            } else {
                return axios(token).put(`/reservations/status/changue/${reservationId}`, payload)
            }
        },
        rejectReservation: (reservationId, supplierId, payload, token = "") => {
            return axios(token).put(`/reservation-reject-supplier/${supplierId}/${reservationId}`, payload);
        },
        canlcelReservationById: (reservationId, reason, refundEligibility, token = "") => {
            return axios(token).put(`/reservations/${reservationId}/cancel`, { reason: reason, refundEligibility: refundEligibility, source: "rhombuss" })
        },
        updateReservationStatusToComfirm: (reservationId, action, operatorId, token = "") => {
            return axios(token).post(`/supplier/confirm/reservations/${reservationId}`, { action: action, operatorId: operatorId });
        },
        /***
         * 
         * History service
         * 
         * ***/
        getHistoriesByReservationId: (reservationId, limit, page, token) => {
            return axios(token).get(`/modules/reservations/${reservationId}/histories?limit=${limit}&page=${page}`)
        },
        updateHistoryById: (historyId, history, token = "") => {
            return axios(token).put(`/histories/${historyId}`, history)
        },
        changeRservationStatus: (reservationId, status, reason, token = "") => {
            return axios(token).patch(`/reservations/${reservationId}/updateAnyStatus`, { status: status, reason: reason })
        },
        resendEmailToUsersByReservationId(reservationId, payload, token = "") {
            return axios(token).post(`/reservations/${reservationId}/resend-email`, payload)
        },
        createPartialDriverProfile: (branchId, driver, token = "") => {
            return axios(token).post(`/branches/${branchId}/drivers`, driver);
        },
        getDriversByBranchId: (branchId, token = "") => {
            return axios(token).get(`/branches/${branchId}/drivers-options`);
        },
        assignDriverByResevationId: (reservationId, payload, token = "") => {
            return axios(token).put(`/reservations/${reservationId}/assign-driver`, payload)
        },
        downloadPDF: (pdfType, identifire, client, voucherType, token = '') => {
            return axios(token).get(`/reservations/${identifire}/generate-pdf?pdfType=${pdfType}&userType=${client.type}&userReference=${client._id}&voucherType=${voucherType}`, {
                responseType: 'blob',
            });
        }
    }
}